import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { PublicHeader } from "@/components/layout/PublicHeader";
import { PublicFooter } from "@/components/layout/PublicFooter";
import { Button } from "@/components/ui/button";
import { PageMeta } from "@/components/seo/PageMeta";
import { Home, ArrowLeft, Search } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* SEO - noindex for 404 pages */}
      <PageMeta
        title="Page Not Found | Tenacity Music"
        description="The page you're looking for doesn't exist. Return to Tenacity Music to continue learning jazz."
        path={location.pathname}
        noIndex={true}
      />

      <PublicHeader />

      <main className="flex-1 pt-32 pb-16 md:pt-40 md:pb-24 flex items-center justify-center px-4 sm:px-6">
        <div className="max-w-lg w-full mx-auto text-center space-y-6">
          <div className="text-7xl sm:text-8xl md:text-9xl font-display font-bold text-primary leading-none">404</div>
          
          <h1 className="text-xl sm:text-2xl md:text-3xl font-display font-bold text-foreground">
            Page Not Found
          </h1>
          
          <p className="text-sm sm:text-base text-muted-foreground max-w-sm mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
            <Button asChild size="lg" className="gap-2">
              <Link to="/">
                <Home className="h-4 w-4" />
                Back to Home
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="gap-2">
              <Link to="/plans">
                View Plans
              </Link>
            </Button>
          </div>

          <div className="pt-6 sm:pt-8 text-sm text-muted-foreground">
            <p>Looking for something specific?</p>
            <div className="flex flex-wrap gap-2 justify-center mt-2">
              <Link to="/about" className="text-primary hover:underline">About</Link>
              <span>•</span>
              <Link to="/faq" className="text-primary hover:underline">FAQ</Link>
              <span>•</span>
              <Link to="/contact" className="text-primary hover:underline">Contact</Link>
            </div>
          </div>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
};

export default NotFound;
